import axios from '../axios';

export const show = (lang = null) => {
  const params = lang
    ? {
        lang,
      }
    : {};

  return axios.get('/for-designers', {
    params,
  });
};

export const submit = (payload) => {
  return axios.post('/for-designers', payload);
};
